var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendarCheckOutline = function SvgCalendarCheckOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2C16.667 2 17 2.31441 17 2.94141V4H18C19.333 4 20 4.667 20 6V12.9189L18 14.9463V10H6V20H9.23438C9.37529 20.334 9.57882 20.6473 9.84766 20.9199L10.9131 22H6C4.667 22 4 21.333 4 20V6.00391C4.00003 4.66797 4.66703 4 6 4H7V3C6.998 2.333 7.33 2 8 2C8.67 2 9.00391 2.333 9.00391 3V4H15V2.94141C15 2.31441 15.333 2 16 2ZM6 8H18V6H6V8Z",
    fill: "#3A3A47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16C10.2879 16 10.5132 16.0624 10.6768 16.1865C10.377 16.3275 10.0949 16.5208 9.84766 16.7715C9.49731 17.1267 9.25615 17.5504 9.12305 18H9C8.333 18.001 8 17.668 8 17C8 16.332 8.33498 15.999 9.00195 16H10Z",
    fill: "#3A3A47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16C15.6585 16 15.9906 16.3246 15.999 16.9746L15.0703 17.917L13.9404 16.7715C13.7308 16.559 13.497 16.3856 13.248 16.252C13.4152 16.0834 13.6666 15.9995 14.002 16H15Z",
    fill: "#3A3A47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12C10.667 12 11 12.333 11 13C11 13.667 10.667 14 10 14H9C8.333 14.001 8 13.668 8 13C8 12.332 8.33498 11.999 9.00195 12H10Z",
    fill: "#3A3A47"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12C15.667 12 16 12.333 16 13C16 13.667 15.667 14 15 14H14C13.333 14.001 13 13.668 13 13C13 12.332 13.335 11.999 14.002 12H15Z",
    fill: "#3A3A47"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7207 14.2837C23.0931 14.6619 23.0931 15.2751 22.7207 15.6533L15.7673 22.7163C15.3949 23.0946 14.7912 23.0946 14.4189 22.7163L11.2793 19.5272C10.9069 19.149 10.9069 18.5358 11.2793 18.1576C11.6516 17.7794 12.2553 17.7794 12.6277 18.1576L15.0931 20.6619L21.3723 14.2837C21.7447 13.9054 22.3484 13.9054 22.7207 14.2837Z",
    fill: "#3A3A47"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarCheckOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-check-outline.ed772aaa.svg";
export { ForwardRef as ReactComponent };